import type { FaireProductEntity } from "../../entity_types/product";

export const p_45dhavxet5: FaireProductEntity = {
  token: "p_45dhavxet5",
  type: "product",
  name: "10\" x 13\" Poly Mailers - Pack of 100",
  brandToken: "b_ajaj2rm3ar",
  brandName: "Store Supply Warehouse",
  imageUrl: "https://cdn.faire.com/fastly/689da86f691d41e74be516d7929dcc8ccf313484ca21138456c9ed1d58cc5163.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9363a7bda9f4fdd0620a3f3bce148f49c9fe2593df739ee12d7cc96fbabc133e.jpeg",
    "https://cdn.faire.com/fastly/deca791e705e53d856d1ce86bfa7649a96378d099d35ac3c6f1227fa5c8d9d52.jpeg",
    "https://cdn.faire.com/fastly/01061b974bf03935e4be6450e0b47d16c62c98d35ee7b002be9e3e1df382f5dd.jpeg",
    "https://cdn.faire.com/fastly/5725267860f69e42066aad0003fc956344ed6b2b73931077d108f46e952f6657.jpeg"
  ],
  priceDollars: 16.5,
  description: "Durable 10\" x 13\" polyethylene mailers for clothing, accessories and other lightweight, non-fragile merchandise. Helps protect contents from moisture, dirt and everyday handling.\n\n- Size: 10\" W x 13\" H\n- Material: polyethylene\n- Self-sealing adhesive closure, no tape needed\n- Quantity: 100 mailers per pack\n\nA convenient supply for boutiques, online sellers and shipping areas.",
  tags: [],
  msrpDollars: 24.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:08.594Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
